import * as actions from './actions';
import { NAME } from './constants';
import Container from './Container';
import reducer from './reducer';

export default { Container, NAME, actions, reducer };
